// NOTICE: KAPTION-INTEGRATION
import AiStudioAPI from '../../api/aiStudio';

const state = {
  token: null,
  uiFlags: {
    isFetchingToken: false,
  },
};

const getters = {
  getAiStudioToken: $state => $state.token,
  getUIFlags: $state => $state.uiFlags,
};

const actions = {
  async fetchToken({ commit }) {
    commit('setUIFlag', { isFetchingToken: true });
    try {
      // Theme is now read from user settings on backend
      // NOTICE: KAPTION-INTEGRATION - Theme detection moved to backend
      const response = await AiStudioAPI.fetchToken();
      commit('setToken', response.data.token);
      commit('setUIFlag', { isFetchingToken: false });
      return response.data;
    } catch (error) {
      commit('setUIFlag', { isFetchingToken: false });
      throw new Error(
        error?.response?.data?.message || 'Failed to generate AI Studio token'
      );
    }
  },
};

const mutations = {
  setToken($state, token) {
    $state.token = token;
  },
  setUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
